import React from 'react';
import { Link } from 'react-router-dom';
import { Wordmark } from '../brand/Wordmark';
import { NewTabHint } from '../ui/NewTabHint';
import { allRoutes, emailAddress, externalLinks } from '../../data/site';
const connectLinks = [{
  label: 'Instagram',
  href: externalLinks.instagram
}, {
  label: 'Discord',
  href: externalLinks.discord
}, {
  label: 'KnightConnect',
  href: externalLinks.knightConnect
}, {
  label: 'Photo Album',
  href: externalLinks.photoAlbum
}, {
  label: 'Get Connected Form',
  href: externalLinks.getConnectedForm
}];
export function Footer() {
  const year = new Date().getFullYear();
  return <footer className="on-dark w-full bg-brand-navy text-white" data-id="element-273" data-mp="3n4lun2kfkolb">
      <div className="mx-auto w-full max-w-6xl px-5 py-14 sm:px-8" data-id="element-274" data-mp="3j28tyskjjgve">
        <div className="grid gap-10 sm:grid-cols-2 sm:gap-12 lg:grid-cols-[1.4fr_1fr_1fr]" data-id="element-275" data-mp="3izw31pwt1w67">
          <div data-id="element-276" data-mp="3e24dv3njoo5p">
            <Wordmark variant="white" className="h-11" data-id="element-277" data-mp="3e4qgqpzhqfhl" />
            <p className="mt-4 max-w-sm font-sans text-[15px] leading-relaxed text-white" data-id="element-278" data-mp="39541yc40kr6o">
              A Christian community for college students at UCF and surrounding campuses.
            </p>
            <p className="mt-4 font-meta text-[13px] font-medium text-brand-yellow" data-id="element-279" data-mp="2p4mpvnrl9szx">
              Thursdays at 7:30 PM during the school year
            </p>
            <a href={externalLinks.email} className="mt-2 inline-block font-meta text-[13px] text-white underline underline-offset-4 hover:text-brand-yellow" data-id="element-280" data-mp="2gb9n7u3q3d0n">
              {emailAddress}
            </a>
          </div>

          <nav aria-label="Footer site links" data-id="element-281" data-mp="381w851l6h0fl">
            <h2 className="font-meta text-xs font-semibold uppercase tracking-[0.18em] text-brand-blue" data-id="element-282" data-mp="2u3fsum9921lu">
              Explore
            </h2>
            <ul className="mt-4 space-y-3" data-id="element-283" data-mp="2z0g0h1lqzcf2">
              {allRoutes.map(route => <li key={route.to} data-id="element-284" data-mp="1imzg50p2xz2o">
                  <Link to={route.to} className="inline-block py-0.5 font-sans text-[15px] text-white hover:text-brand-yellow" data-id="element-285" data-mp="1iq3ugqw9eb72">
                    {route.label}
                  </Link>
                </li>)}
            </ul>
          </nav>

          <nav aria-label="Footer connect links" data-id="element-286" data-mp="us5wmh5qrpfc">
            <h2 className="font-meta text-xs font-semibold uppercase tracking-[0.18em] text-brand-blue" data-id="element-287" data-mp="uquvkp3okvrx">
              Connect
            </h2>
            <ul className="mt-4 space-y-3" data-id="element-288" data-mp="ku86tp88hkkm">
              {connectLinks.map(link => <li key={link.label} data-id="element-289" data-mp="fv544bfq7qft">
                  <a href={link.href} target="_blank" rel="noopener noreferrer" className="inline-block py-0.5 font-sans text-[15px] text-white hover:text-brand-yellow" data-id="element-290" data-mp="fu3sa4qvyzx1">
                    {link.label}
                    <NewTabHint data-id="element-291" data-mp="266jijggxpusq" />
                  </a>
                </li>)}
            </ul>
          </nav>
        </div>

        <p className="mt-12 font-meta text-[13px] text-white" data-id="element-292" data-mp="216ey5fcwofx8">
          © {year} UCF Baptist Collegiate Ministries
        </p>
      </div>
    </footer>;
}